(() => {
    Metro.i18n.add("pl", {
        weekStart: 1,

        january: "Styczeń",
        february: "Luty",
        march: "Marzec",
        april: "Kwiecień",
        may: "Maj",
        june: "Czerwiec",
        july: "Lipiec",
        august: "Sierpień",
        september: "Wrzesień",
        october: "Październik",
        november: "Listopad",
        december: "Grudzień",

        january_short: "Sty",
        february_short: "Lut",
        march_short: "Mar",
        april_short: "Kwi",
        may_short: "Maj",
        june_short: "Cze",
        july_short: "Lip",
        august_short: "Sie",
        september_short: "Wrz",
        october_short: "Paź",
        november_short: "Lis",
        december_short: "Gru",

        sunday: "Niedziela",
        monday: "Poniedziałek",
        tuesday: "Wtorek",
        wednesday: "Środa",
        thursday: "Czwartek",
        friday: "Piątek",
        saturday: "Sobota",

        sunday_short: "Nd",
        monday_short: "Pn",
        tuesday_short: "Wt",
        wednesday_short: "Śr",
        thursday_short: "Czw",
        friday_short: "Pt",
        saturday_short: "Sob",

        sunday_short_2: "N",
        monday_short_2: "P",
        tuesday_short_2: "W",
        wednesday_short_2: "Ś",
        thursday_short_2: "C",
        friday_short_2: "P",
        saturday_short_2: "S",

        label_ok: "OK",
        label_cancel: "Anuluj",
        label_done: "Gotowe",
        label_today: "Dzisiaj",
        label_now: "Teraz",
        label_clear: "Wyczyść",
        label_help: "Pomoc",
        label_yes: "Tak",
        label_no: "Nie",
        label_random: "Losowy",
        label_save: "Zapisz",
        label_reset: "Resetuj",
        label_submit: "Wyślij",
        label_add_user_color: "Dodaj do kolorów",
        label_send: "Wyślij",
        label_accept: "Akceptuj",
        label_cookies_title: "Ta strona używa plików cookie",
        label_cookies_text: "Ta strona używa plików cookie, aby zapewnić najlepsze doświadczenie na naszej stronie.",
        label_choose_file: "Wybierz plik(i)",
        label_drop_file: "Kliknij lub upuść plik(i) tutaj",
        label_files_selected: "Wybrano {n} plik(ów)",

        label_days: "dni",
        label_hours: "godziny",
        label_minutes: "minuty",
        label_seconds: "sekundy",
        label_month: "miesiąc",
        label_months: "miesiące",
        label_day: "dzień",
        label_year: "rok",
        label_years: "lata",

        label_rows_count: "Pokaż:",
        label_search: "Szukaj:",
        label_table_info: "Wyświetlanie od $1 do $2 z $3 wpisów",
        label_prev: "Poprzedni",
        label_next: "Następny",
        label_all: "Wszystko",
        label_inspector: "Inspektor",
        label_goto_page: "Idź do",
        label_enter_page: "Wpisz stronę...",
        label_empty: "Brak danych do wyświetlenia",
        label_user_colors: "Kolory użytkownika",
        label_tiles: "Kafelki",
        label_list: "Lista",
        label_load_more: "Załaduj więcej",
        label_buy: "Kup",
        label_buy_now: "Kup teraz",
        label_buy_today: "Kup dzisiaj",
        label_download: "Pobierz",
        label_search_results: "Wyniki wyszukiwania",
        label_add: "Dodaj",
        label_edit: "Edytuj",
        label_delete: "Usuń",
        label_new: "Nowy",
        label_sell: "Sprzedaj",
        label_details: "Szczegóły",
        label_sorting: "Sortowanie",
        label_finish: "Zakończ",
        label_play: "Odtwórz",
        label_pause: "Pauza",
        label_stop: "Zatrzymaj",
        label_mute: "Wycisz",
        label_loop: "Zapętl",

        label_on: "włą",
        label_off: "wył",

        label_rename_tab: "Zmień nazwę karty",
        label_close_tab: "Zamknij kartę",
        label_close_other_tabs: "Zamknij inne karty",
        label_close_tabs_left: "Zamknij karty po lewej",
        label_close_tabs_right: "Zamknij karty po prawej",
        label_close_all_tabs: "Zamknij wszystkie karty",
        label_close_inactive_tabs: "Zamknij nieaktywne karty",

        label_clear_input: "Wyczyść pole",
        label_reveal_password: "Pokaż hasło",
        label_hide_password: "Ukryj hasło",
        label_generate_random: "Wygeneruj losową wartość",
        label_search_input: "Szukaj wprowadzonej wartości",

        label_note: "Notatka",
        label_tip: "Wskazówka",
        label_info: "Informacja",
        label_warning: "Ostrzeżenie",
        label_question: "Pytanie",
        label_error: "Błąd",
        label_success: "Sukces",
        label_caution: "Uwaga",
        label_alert: "Alarm",
        label_bug: "Błąd",
        label_fuck: "Cholera",
        label_important: "Ważne",
        label_shit: "Kurka",
        label_air: "Powietrze",

        label_select_all: "Zaznacz wszystko",
        label_select_more: "Wybierz...",
        label_select: "Wybierz",
        label_filter: "Filtruj",

        label_collapse: "Zwiń",
        label_attach: "Przytwierdzać",
    });
})();
